import { httpAPI } from "@/api/httpAPI";
import moment from 'moment';

const Uptime = 30;

const isOutdated = (moment, sync, uptime) => {
    let now = moment(Date.now());
    let syncTime = moment(sync);
    return moment.duration(now.diff(syncTime)).asMinutes() > uptime;
};

const planner = {
    namespaced: true,
    state: {
        /*
            1 - левое меню по сферам
            2 - левое меню по месяцам
            3 - календарь
        */
        mode: "2",
        menuLoading: true,

        id: null,
        menuItemName: null,

        identifiers: null,

        search: null,
        filterCategory: [null],
        filterStatus: null,
        filterBoardId: null,
        filterContolId: null,
        filterEnterprise: null,
        calendarDate: null,

        meetingCategories: [
            { id: 1, Value: "Участие_АО", icon: "fas fa-landmark", color: "#448aff" },
            { id: 2, Value: "Участие_ЗАО", icon: "fas fa-landmark", color: "#7c4dff" },
            { id: 3, Value: "Поручение_ГГ_и_ПМ", icon: "fas fa-flag", color: "#ff5252" },
            { id: 4, Value: "Поручение_АО", icon: "fas fa-flag", color: "#448aff" },
            { id: 5, Value: "Обращения", icon: "fas fa-envelope", color: "#ffab40" },
            { id: 6, Value: "Ввод_объектов_и_кап._ремонты", icon: "fas fa-tools", color: "#b0bec5" },
            { id: 7, Value: "Алишев Р. К.", icon: "fas fa-user-tie", color: "#7cb342" },
            { id: 8, Value: "Тасмаганбетов М. И.", icon: "fas fa-user-tie", color: "#7cb342" },
            { id: 9, Value: "Дузелбаев К. М.", icon: "fas fa-user-tie", color: "#7cb342" },
            { id: 10, Value: "Курманов Р. Ж.", icon: "fas fa-user-tie", color: "#7cb342" },
            { id: 11, Value: "Жумагулов Ж. Р.", icon: "fas fa-user-tie", color: "#7cb342" }
        ],
        meetingStatuses: [
            { id: 1, Value: "Завершено" },
            { id: 2, Value: "Запланировано" }
        ],
        meetingMonths: [
            { id: 1, Value: "Январь", color: "#82B1FF" }, //blue accent-1 #82B1FF
            { id: 2, Value: "Февраль", color: "#80D8FF" }, //light-blue accent-1 #80D8FF
            { id: 3, Value: "Март", color: "#B9F6CA" }, //green accent-1 #B9F6CA
            { id: 4, Value: "Апрель", color: "#CCFF90" }, //light-green accent-1 #CCFF90
            { id: 5, Value: "Май", color: "#F4FF81" }, //lime accent-1 #F4FF81
            { id: 6, Value: "Июнь", color: "#FFE57F" }, //amber accent-1 #FFE57F
            { id: 7, Value: "Июль", color: "#FFD180" }, //orange accent-1 #FFD180
            { id: 8, Value: "Август", color: "#FF9E80" }, //deep-orange accent-1 #FF9E80
            { id: 9, Value: "Сентябрь", color: "#FF80AB" }, //pink accent-1 #FF80AB
            { id: 10, Value: "Октябрь", color: "#EA80FC" }, //purple accent-1 #EA80FC
            { id: 11, Value: "Ноябрь", color: "#B388FF" }, //deep-purple accent-1 #B388FF
            { id: 12, Value: "Декабрь", color: "#8C9EFF" } //indigo accent-1 #8C9EFF
        ],
        meetingYears: [
            2025,
            2026
        ],
        selectedYear: null,
        weekDays: [
            {id: 1, Value: "Понедельник", ShortVal: "Пн"},
            {id: 2, Value: "Вторник", ShortVal: "Вт" },
            {id: 3, Value: "Среда", ShortVal: "Ср" },
            {id: 4, Value: "Четверг", ShortVal: "Чт" },
            {id: 5, Value: "Пятница", ShortVal: "Пт" },
            {id: 6, Value: "СУббота", ShortVal: "Сб" },
            {id: 7, Value: "Воскресенье", ShortVal: "Вс" },
        ],

        creationBag: null,

        boards: [],

        curators: [],
        curatorsSync: 0,
    },
    mutations: {
        SET_MODE(state, payload) {
            state.mode = payload;
        },
        SET_MENU_LOADING(state, payload) {
            state.menuLoading = payload;
        },
        SET_ID(state, payload) {

            if (!state.identifiers)
                state.identifiers = {};

            state.identifiers[state.mode] = payload;

            state.id = payload;            
        },
        SET_MENU_ITEM_NAME(state, payload) {
            state.menuItemName = payload;
        },
        SET_SEARCH(state, payload) {
            state.search = payload;
        },
        SET_CREATION_BAG(state, payload) {
            state.creationBag = payload;
        },
        SET_FILTER_CATEGORY(state, payload) {
            state.filterCategory = payload;
        },
        SET_FILTER_STATUS(state, payload) {
            state.filterStatus = payload;
        },
        SET_FILTER_BOARD_ID(state, payload) {
            state.filterBoardId = payload;
        },
        SET_FILTER_CONTROL_ID(state, payload) {
            state.filterContolId = payload;
        },
        SET_BOARDS (state, payload) {
            state.boards = payload;
        },
        SET_CURATORS (state, payload) {
            state.curators = payload;
        },
        SET_FILTER_ENTERPRISE(state, payload) {
            state.filterEnterprise = payload;
        },
        SET_IDENTIFIERS(state, payload) {
            state.identifiers = payload;
        },
        SET_CALENDAR_DATE(state, payload) {
            state.calendarDate = payload;
        },
        SET_SELECTED_YEAR(state, payload) {
            state.selectedYear = payload;
        }
    },
    actions: {
        async loadBoards({ commit }, enterprise) {
            let response = await httpAPI({
                url: `api/plannedevent/boardlist?filter=${JSON.stringify({ Enterprise: enterprise })}`,
                method: 'GET'
            });

            commit('SET_BOARDS', response?.data?.Payload ?? []);
        },
        async getCurators({state, commit}){
            if (!state.curators || state.curators.length == 0 || isOutdated(this._vm.$moment, state.curatorsSync, Uptime)){
                let response = await httpAPI.get('api/plannedevent/curatorslist');

                commit('SET_CURATORS', response?.data?.Payload ?? []);
            }
            return state.curators;
        }
    },
    getters: {
        getMode: (s) => s.mode,
        isMenuLoading: (s) => s.menuLoading,
        getId: (s) => s.id,
        getMenuItemName: (s) => s.menuItemName,
        getSearch: (s) => s.search,
        getMeetingCategories: (s) => s.meetingCategories,
        getMeetingStatuses: (s) => s.meetingStatuses,
        getMeetingMonths: (s) => s.meetingMonths,
        getMeetingYears: (s) => s.meetingYears,
        getSelectedYear:(s) => s.selectedYear ?? new Date().getFullYear(),
        getCreationBag: (s) => s.creationBag,
        getFilterCategory: (s) => s.filterCategory,
        getFilterStatus: (s) => s.filterStatus,
        getFilterBoardId: (s) => s.filterBoardId,
        getWeekDays: (s) => s.weekDays,
        getIdentifiers: (s) => s.identifiers,
        getFilterControlId: (s) => s.filterContolId,
        getFilterEnterprise: (s, g, rS, rG) => s.filterEnterprise == null ? rG['global/auth/getUserEnterpriseId'] : s.filterEnterprise,
        getBoards: (s) => s.boards,
        getCalendarDate: (s) => s.calendarDate ?? moment().format('YYYY-MM-DD')
    }
}

export default planner;